

















import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '../components/SearchBar.vue';
import VoteList from '../components/VoteList.vue';
@Component({
  components: {
    SearchBar,
    VoteList,
  },
})
export default class List extends Vue {
  activeType = '1';
  searchText = '请输入作者或作品名称';
  tab = [
    { text: '绘画', id: '1' },
    { text: '海报', id: '3' },
  ];
  id: number = 1;
  changeTab(item: any) {
    this.id = parseInt(item.id);
    this.activeType = item.id;
  }
}
